/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import Download from '@images/svg/icons/icon-download.svg'
import Image from '@images/svg/icons/icon-image.svg'
import Profile from '@images/svg/icons/icon-profile.svg'
import Share from '@images/svg/icons/icon-share.svg'
import Video from '@images/svg/icons/icon-video.svg'
import Data from '@images/svg/icons/icon-data.svg'
import GCode from '@images/svg/icons/icon-gcode.svg'
import Iot from '@images/svg/icons/icon-iot.svg'
import Unreal from '@images/svg/icons/icon-unreal.svg'
import Audio from '@images/svg/icons/icon-audio.svg'
import Ethereum from '@images/png/icons/ico-ethereum.png'
import Zetonium from '@images/png/icons/ico-zetonium.png'
import Polygon from '@images/png/icons/ico-polygon.png'
import Near from '@images/png/icons/ico-near.png'
import Flow from '@images/png/icons/ico-flow.png'
import Pdf from '@images/svg/icons/ico-pdf.svg'
import VideoToggle from '@images/svg/icons/icon-video-toggle.svg'
import ImageToggle from '@images/svg/icons/icon-image-toggle.svg'
import DataToggle from '@images/svg/icons/icon-data-toggle.svg'
import GCodeToggle from '@images/svg/icons/icon-gcode-toggle.svg'
import IotToggle from '@images/svg/icons/icon-iot-toggle.svg'
import UnrealToggle from '@images/svg/icons/icon-unreal-toggle.svg'
import AudioToggle from '@images/svg/icons/icon-audio-toggle.svg'

export const IconsList = ({ icon, asImage, className = '', ...props }) => {
  const icons = {
    audio: asImage ? Audio : null,
    data: asImage ? Data : null,
    download: asImage ? Download : <Download { ...props } />,
    ethereum: asImage ? Ethereum : null,
    flow: asImage ? Flow : null,
    gcode: asImage ? GCode : null,
    image: asImage ? Image : <Image { ...props } />,
    iot: asImage ? Iot : null,
    near: asImage ? Near : null,
    pdf: asImage ? Pdf : null,
    polygon: asImage ? Polygon : null,
    profile: asImage ? Profile : <Profile { ...props } />,
    share: asImage ? Share : <Share { ...props } />,
    unknown: asImage ? Data : null,
    unreal: asImage ? Unreal : null,
    video: asImage ? Video : null,
    zetonium: asImage ? Zetonium : null,
    'audio-toggle': asImage ? AudioToggle : null,
    'data-toggle': asImage ? DataToggle : null,
    'gcode-toggle': asImage ? GCodeToggle : null,
    'image-toggle': asImage ? ImageToggle : null,
    'iot-toggle': asImage ? IotToggle : null,
    'unreal-toggle': asImage ? UnrealToggle : null,
    'video-toggle': asImage ? VideoToggle : null
  }

  return asImage
    ? <img src={icons[icon] || icons.image} className={className} { ...props } />
    : icons[icon] || icons.image
}

export default IconsList
